<template>
  <path
    fill="currentColor"
    d="M16.214 7.63504C17.4714 7.63477 18.4278 8.90026 18.0553 10.1212L16.7188 14.6064C16.0236 16.8636 14.7752 17.9523 12.8988 17.9523C10.0959 17.9523 7.80991 17.8053 5.20918 16.5457C5.08842 16.4872 5.01172 16.3649 5.01172 16.2307V8.30998C5.01172 8.06561 5.26752 7.98229 5.53295 7.89582C5.73771 7.82912 5.9482 7.76055 6.05143 7.61474L9.47512 2.76416C10.1168 1.85518 11.5127 1.79572 12.2239 2.67174C12.5932 3.12399 12.7043 3.7343 12.5179 4.28767L11.5181 6.38319C11.2493 6.94522 11.6713 7.63519 12.3072 7.63504H16.214Z" />
  <path
    fill="currentColor"
    d="M2.75 7.5C3.30229 7.5 3.75 7.94772 3.75 8.5L3.75 16.5C3.75 17.0523 3.30228 17.5 2.75 17.5H1.75C1.47386 17.5 1.25 17.2761 1.25 17V8C1.25 7.72386 1.47386 7.5 1.75 7.5H2.75Z" />
</template>
